var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.92251 0.744078C9.24794 1.06951 9.24794 1.59715 8.92251 1.92259L4.75584 6.08926C4.4304 6.41469 3.90277 6.41469 3.57733 6.08926L1.07733 3.58926C0.751893 3.26382 0.751893 2.73618 1.07733 2.41074C1.40277 2.08531 1.9304 2.08531 2.25584 2.41074L4.16659 4.32149L7.744 0.744078C8.06943 0.418641 8.59707 0.418641 8.92251 0.744078Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.13323d3f4c19b9be206b44da29bc2226.svg";
export { ForwardRef as ReactComponent };